<template>
  <div class="container flex" style="margin-bottom: 20px;">
      <div><left></left></div>
      <div class="live flex1" style="margin-left: 20px;background-color: #fff;">
      	<div class="title">
      		免费直播
      	</div>
      	<div class="lists" v-for="item in list">
      		<div class="listtile flex list">
      			<span class="flex1">{{item.liveLessonName}}</span>
            <div class="viewWrap" v-if="item.liveLessonUrl">
            	<span class="view" @click="handleView(item.liveLessonUrl)">查看</span>
            </div>
      		</div>
      		<div class="list" v-for="voo in item.childLiveLessonList">
      			<span class="childName">{{voo.liveLessonName}}</span>
      			<div class="viewWrap" v-if="voo.liveLessonUrl">
      				<span class="view" @click="handleView(voo.liveLessonUrl)">查看</span>
      			</div>
      		</div>
      	</div>
      </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          list:[]
      }
    },
    methods:{
      handleView(url){
        window.open(url)
      },
      getData(){
        this.$axios.get(this.$common.about_liveCourse).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData();
    }
  }
</script>

<style scoped="">
  .live .lists {
    text-indent: 40px;
  }
  .live .lists .list .childName {
    text-indent: 66px;
  }
</style>



// WEBPACK FOOTER //
// src/components/live.vue